import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Compra } from '../../../models/compra';
import { CompraListModalComponent } from '../../../components/modals/compra-list-modal/compra-list-modal.component';
import * as numeral from 'numeral';
import { CompraDetalle } from '../../../models/compra_detalle';
import { ImpuestoService } from '../../../services/impuesto.service';
import { Impuesto } from '../../../models/impuesto';
import { Retencion } from '../../../models/retencion';
import { RetencionDetalle } from '../../../models/retencion_detalle';
import { ParametroService } from '../../../services/parametro.service';
import { SessionService } from '../../../services/session.service';
import { Validation } from '../../../config/validation';
import { ComprobanteService } from '../../../services/comprobante.service';
import { SweetMessage } from '../../../config/sweet-message';
import { RetencionService } from '../../../services/retencion.service';
import { Caja } from '../../../models/caja';
import{ CajaService } from '../../../services/caja.service';
import { CbtContadorService } from '../../../services/cbt-contador.service';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';
import * as moment from 'moment';
import { UtilsService } from '../../../services/utils.service';
import { CompraFilterModalComponent } from '../../modals/compra-filter-modal/compra-filter-modal.component';
import { CompraService } from '../../../services/compra.service';
import { Comprobante } from '../../../models/comprobante';
import { RetencionRentaModalComponent } from '../../modals/retencion-renta-modal/retencion-renta-modal.component';
import { ValidarCorreoService } from '../../../services/validar-correo.service';
import { AsientoContable } from '../../../models/asiento-contable';
import { PeriodoContable } from '../../../models/periodo-contable';
import { AsientoContableDetalle } from '../../../models/asiento-contable-detalle';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { ParametroContabilidad } from '../../../models/parametro-contabilidad';
import { ParametroContabilidadService } from '../../../services/parametro-contabilidad.service';

@Component({
	selector: 'retenciones-compra-add',
	templateUrl: './retenciones-compra-add.component.html',
	styleUrls: ['./retenciones-compra-add.component.css'],
	providers: [
		ImpuestoService,
		ParametroService, 
		RetencionService,
		ComprobanteService,
		CajaService,
		ImpuestoPorcentajeService,
		CompraService,
		ValidarCorreoService,
		PeriodoContableService,
		ParametroContabilidadService,
	]
})
export class RetencionesCompraAddComponent implements OnInit {
	public bsModalRef: BsModalRef;
	public compra: Compra;
	public retencion: Retencion;
	public retencion_detalle: Array<RetencionDetalle>;
	public impuestos: Array<Impuesto>;
	public parametrosImp: Array<any>;
	public validDateFecha: Boolean;
	public vl: Validation;
	public msgSweet: SweetMessage;
	public total: number;
	public loading = false;
	public cajas: Array<Caja>;
	public caja: Caja;
	public Mod_FactElec: string;
	public fecha_emision;
	public is_numero_manual: boolean;
	public numero_documento: String;
	//public impuesto_porcentaje: Array<any>;
	public impuesto_porcentaje_iva: Array<any>;
	public impuesto_porcentaje_renta: Array<any>;
	public fecha_actual;
	public fecha_MesAnt;
	public correos: Array<any>;
	public numero_decimales: number;
	public format_decimal: String;
	public calculo_decimales: number;
	public correo_invalid:Boolean;

	public Mod_Cartera: string;
	public Mod_Contabilidad: string;

	public parametrosContabilidad: Array<ParametroContabilidad>;
	public periodoContable: PeriodoContable;
	public totalRenta: number;
	public totalIva: number;
	@Input() modal: boolean;
	@Input() compra_id: String;
	@Output() cerrarModal = new EventEmitter();

	constructor(
		private modalService: BsModalService,
		public impuestoService: ImpuestoService,
		public parametroService: ParametroService,
		private ss: SessionService,
		public comprobanteService: ComprobanteService,
		public retencionService: RetencionService,
		public cajaService: CajaService,
		public cbtContadorService: CbtContadorService,
		private impuestoPorcentajeService: ImpuestoPorcentajeService,
		public utils: UtilsService,
		public compraService : CompraService,
		public correoService: ValidarCorreoService,
		private periodoContableService: PeriodoContableService,
		private parametroContabilidadService: ParametroContabilidadService,
		//public bsModalRefModal: BsModalRef,
	) {
		this.compra = new Compra();
		this.retencion = new  Retencion();
		this.retencion_detalle = [];
		this.impuestos = [];
		this.parametrosImp = [];
		this.vl = new Validation();
		this.msgSweet = new SweetMessage();
		this.total = 0;
		this.cajas = [];
		this.caja = new Caja();
		this.Mod_FactElec = "";
		this.fecha_emision = moment(this.fecha_emision);
		this.fecha_actual = moment(this.fecha_actual);
        this.fecha_MesAnt = moment(this.fecha_actual.subtract(1, 'months'));
		this.is_numero_manual = false;
		this.numero_documento = "";
		this.impuesto_porcentaje_iva = [];
		this.impuesto_porcentaje_renta = [];
		this.correos = [];
		this.numero_decimales = 2;
		this.calculo_decimales = 2;
		this.format_decimal = "0,0.00";
		this.modal = false;
		this.compra_id = "";
		this.correo_invalid = false;
		this.Mod_Cartera = this.ss.getData("mod_cartera");
		this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
		this.parametrosContabilidad = [];
		this.periodoContable = new PeriodoContable();

		this.totalRenta = 0;
		this.totalIva = 0;
		this.compra.fecha_emision = moment();
	}

	ngOnInit() {
		//this.onIniDate();
		this.loading = true;
		
        let p1 = this.getCajas();
		let p2 = this.getImpuestos();
		let p3 = this.getParametros();
		let p4 = this.getParamDocumentoManual();
		//let p5 = this.getImpuestoPorcentaje();
		let p6 = this.getParamNumeroDecimales();
		let p5 = this.getImpuestoPorcentaje(2);
		let p7 = this.getImpuestoPorcentaje(1);
		let p8 = this.getParametroContabilidadRetenciones();
		this.loading = true;
		Promise.all([p1,p2,p3,p4,p5,p7,p8]).then(
			res => this.loading = false,
			err => this.loading = false,
		);
		this.Mod_FactElec = this.ss.getData("mod_felectronica");

		
		if(this.compra_id != ""){
			this.compra.id = this.compra_id;
			this.getDataCompra(this.compra);
		}
		
		
		Promise.all([p1,p2,p3,p4,p5,p6,p7]).then(
			res => this.loading = false,
			err => this.loading = false
		);

		/*this.globals.subCbtsRestantes(1).subscribe(
			res => {}
		);*/

		

		
	}

	getImpuestos(){
		return new Promise((resolve, reject) => {
			this.impuestoService.getAll().subscribe(
				res => {
					let impuestos = [];
					impuestos = res.data;
					let result= impuestos.filter(i=>i.id!='4');
					this.impuestos = result;
					resolve();
				},
				err => {
					this.impuestos = [];
					reject(err);
				}
			);
		});
	}

	getImpuestoPorcentaje(impuesto_id){
		let qs = "?impuesto_id=" + impuesto_id+"&is_tarifa=0&is_vigente=1";
		return new Promise((resolve, reject) => {
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					if( res.data[0].impuesto_id == 2){
						this.impuesto_porcentaje_iva = res.data;
					}else{
						this.impuesto_porcentaje_renta = res.data;
					}
					
					resolve();
				}, err => {
					this.impuesto_porcentaje_iva = [];
					this.impuesto_porcentaje_renta = [];
					reject();
				}
			);
		});
	}

	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    get formatDecimal(){
        return this.format_decimal;
    }

	getParametros(){
		return new Promise((resolve, reject) => {
			this.parametroService.getAll("?in[id]=3,4,5,6").subscribe(
				res => {
					this.parametrosImp = res.data;
					resolve();
				},
				err => {
					this.parametrosImp = [];
					reject(err);
				}
			);
		});
	}

	getCajas(){
		return new Promise((resolve, reject) => {
			this.cajaService.getAll("?embed=sucursal&sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
				res => {
					this.cajas = res.data;
					if( this.cajas.length == 1 ){
						
						this.caja.id = this.cajas[0].id;
					
						this.onChangeCaja();
					}
					resolve();
				},
				err => {
					this.cajas = [];
					reject(err);
				}
			);
		});
	}
	
	onChangeCaja(){
        this.caja = this.cajas.filter(x => x.id = this.caja.id)[0];
        if( !this.caja ){
            this.caja = new Caja();
		}

		this.getNumeroComprobante();
    }

	getNumeroComprobante(){
		if( !this.caja.id ){
            this.msgSweet.showMessage('error-message', "Seleccione la caja");
            return;
		}
		
		this.loading = true;

		if(this.Mod_FactElec){
			this.retencion.tipo_comprobante_id = 5;
		}
		else{
			this.retencion.tipo_comprobante_id = 3;
		}
        this.comprobanteService.getSecuencial(this.retencion.tipo_comprobante_id, this.caja.id).subscribe(
            res => {
				this.loading = false;
                if(res.secuencial){
                    this.retencion.serie = this.caja.sucursal.establecimiento;
                    this.retencion.punto_emision = this.caja.punto_emision;
                    this.retencion.secuencial = res.secuencial;

					this.retencion.numero_documento = this.retencion.serie + "-" + this.retencion.punto_emision + "-" + this.retencion.secuencial;
					
                }else{
                    this.retencion.serie = "";
                    this.retencion.punto_emision = "";
                    this.retencion.secuencial = "";
                    this.retencion.numero_documento = "";
                }
            },
            err => {
				this.loading = false;
                this.retencion.serie = "";
                this.retencion.punto_emision = "";
                this.retencion.secuencial = "";
                this.retencion.numero_documento = "";
                
                this.msgSweet.showMessage('error-message', err);
            }
        );
	}
	
	getParamDocumentoManual(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let documento_manual_id = 9;
            this.parametroService.getById(documento_manual_id).subscribe(
                res => {
                    this.is_numero_manual = (res.valor.toString().trim() === "SI");
                    resolve();
                },
                err => {
                    this.is_numero_manual = false;
                    reject(err);
                }
            );
        });
    }

	onIniDate() {
		let today = new Date();
		let dd = today.getDate();
		let mm = today.getMonth() + 1; //January is 0!
		let dia = "";
		let mes = "";

		var yyyy = today.getFullYear();
		dia = "" + dd;
		mes = "" + mm;
		if (dd < 10) {
			dia = "0" + dd;
		}
		if (mm < 10) {
			mes = "0" + mm;
		}
		let today2 = dia + '/' + mes + '/' + yyyy;
		this.retencion.fecha_emision = today2;
		this.retencion.fecha_caducidad = today2;
	}

	onValidDateFecha(fecha){
        return this.validDateFecha = this.vl.validDate(fecha.toString());
	}
	
	openModalRetencionRenta(detalle){
		
		const initialState = {impuesto_porcentaje_renta: this.impuesto_porcentaje_renta};
		this.bsModalRef = this.modalService.show(RetencionRentaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendImpuestoRenta.take(1).subscribe(impuesto_renta => {
			detalle.codigo = impuesto_renta.codigo;
			detalle.porcentaje = impuesto_renta.porcentaje;
			detalle.cuenta_contable_id = impuesto_renta.cuenta_contable_id;
			//this.loading = true;
			this.recalcular(detalle);
			
		});
		
	}

	onSearch(id){
		let qs = "";//"&embed=retencion";
		this.correos = [];
		const initialState = { qs, numero_decimales: this.numero_decimales };
		this.bsModalRef = this.modalService.show(CompraFilterModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.onSelectedRow.take(1).subscribe(compra => {
			
			this.getDataCompra(compra);
			/*this.compraService.getById(compra.id, "?embed=proveedor?embed=tipoidentificacion,bodega,cliente,guiaremision,retencion,detalle?embed=producto").subscribe(res=>{
				this.compra = res.data; 
			},err=>{
	
			});*/
			// if( compra.retencion ){
			// 	this.msgSweet.showMessage('error-message','La factura seleccionada ya tiene una retención');
			// }else{
			// 	this.compra = compra;
			// 	//this.correos = this.compra.proveedor.correo.split(',');
				
			// 	if( this.compra.proveedor.correo.trim().length ){
			// 		this.correos = this.compra.proveedor.correo.split(',');
			// 	}
			// 	//this.calcularRetencion();
			// }
			/*if( this.compra.proveedor.correo.trim().length ){
				this.correos = this.compra.proveedor.correo.split(',');
			}*/
		});
	}

	getDataCompra(compra){
		this.compraService.getById(compra.id, "?embed=proveedor?embed=tipoidentificacion,bodega,cliente,guiaremision,retencion,detalle?embed=producto").subscribe(res=>{
			this.compra = res.data; 
			
			if( this.compra.proveedor.correo.trim().length ){
				this.correos = this.compra.proveedor.correo.split(',');
			}
			
		},err=>{

		});
		
	}

	calcularItemRetencion(impuesto_id, parametro_id, subtotal){
		let retencion_detalle;
		retencion_detalle = new RetencionDetalle();
		retencion_detalle.base_imponible = parseFloat(subtotal);
		retencion_detalle.impuesto_id = impuesto_id;
		retencion_detalle.impuesto = this.impuestos.filter(x => x.id===impuesto_id)[0];
		retencion_detalle.porcentaje = parseFloat(this.parametrosImp.filter(x => x.id===parametro_id)[0].valor);
		retencion_detalle.total = retencion_detalle.base_imponible * (retencion_detalle.porcentaje / 100);
		retencion_detalle.empresa_id = this.ss.getData('empresa_id');
		retencion_detalle.sucursal_id = this.ss.getData('sucursal_id');
		retencion_detalle.usuario_id = this.ss.getData('usuario_id');
		this.total += retencion_detalle.total;

		this.retencion_detalle.push(retencion_detalle);
	}
	
	calcularRetencion(){
		let subtotal_servicio = 0;
		let subtotal_producto = 0;
		let iva_servicio = 0;
		let iva_producto = 0;
		this.total = 0;
		
		this.compra.detalle.forEach((compra_detalle: CompraDetalle) => {
			// if( compra_detalle['producto']['es_servicio'] ){

			if( compra_detalle['producto']['tipo_producto_id'] == '2' ){
				subtotal_servicio += parseFloat(compra_detalle.subtotal.toString());
				iva_servicio += parseFloat(compra_detalle.iva.toString());
			}else{
				subtotal_producto += parseFloat(compra_detalle.subtotal.toString());
				iva_producto += parseFloat(compra_detalle.iva.toString());
			}
		});
	}

	getParametroContabilidadRetenciones(){
        return new Promise((resolve, reject) => {
            let qs = "?in[id]=33,34,35,36&embed=cuentacontable";
            if( this.Mod_Cartera && this.Mod_Contabilidad ) {
                this.parametroContabilidadService.getAll(qs).subscribe(
                    res => {
                        
                        this.parametrosContabilidad = res.data;
                        let is_confirmedParametros = true;
                        this.parametrosContabilidad.forEach(parametroContabilidad => {
                            if( parametroContabilidad.cuenta_contable_id == null ){
                                is_confirmedParametros = false;
                                return false;
                            }
                        });
                        if(!is_confirmedParametros){
                            this.msgSweet.showMessage('error-message', "Por favor, confirmar los parámetros de las cuentas contables.");
                        }
                        resolve();
                    },
                    err => {
                        reject(err);
                    }
                );
            }
            
        });
	}
	

	setValueAsientoContable(){
        
        let asientoContable = new AsientoContable();
        let asientoContableCobros = new AsientoContable();
        asientoContable.fecha_emision = this.retencion.fecha_emision;
        asientoContable.tipocomprobante = this.retencion.tipocomprobante;
        asientoContable.tipo_comprobante_id = this.retencion.tipo_comprobante_id.toString();
        asientoContable.periodo_contable_id = this.periodoContable.id;
        asientoContable.numero_documento = this.retencion.serie + '-' + this.retencion.punto_emision + '-' + this.retencion.secuencial;
        asientoContable.descripcion = this.compra.proveedor.nombre_comercial;
        asientoContable.empresa_id = this.retencion.empresa_id;
        asientoContable.usuario_id = this.retencion.usuario_id;
		asientoContable.total = this.retencion.total;
		asientoContable.status = 'A';
        asientoContableCobros.fecha_emision = this.retencion.fecha_emision;
        asientoContableCobros.tipocomprobante = this.retencion.tipocomprobante;
        asientoContableCobros.tipo_comprobante_id = this.retencion.tipo_comprobante_id.toString();
        asientoContableCobros.periodo_contable_id = this.periodoContable.id;
        asientoContableCobros.numero_documento = this.retencion.serie + '-' + this.retencion.punto_emision + '-' + this.retencion.secuencial;
        asientoContableCobros.descripcion = this.compra.proveedor.nombre_comercial;
        asientoContableCobros.empresa_id = this.retencion.empresa_id;
        asientoContableCobros.usuario_id = this.retencion.usuario_id;
        asientoContableCobros.total = this.retencion.total;
        asientoContableCobros.status = 'A';
        this.parametrosContabilidad.forEach(parametroContabilidad => {
            let asientoContableDetalle = new AsientoContableDetalle;
            asientoContableDetalle.empresa_id = asientoContable.empresa_id;
            asientoContableDetalle.usuario_id = asientoContable.usuario_id;
            asientoContableDetalle.haber = 0;

            if( parametroContabilidad.id == "35" && this.totalRenta > 0 ) {
				parametroContabilidad.tipo_saldo = "H";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.totalRenta:0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.totalIva:0;
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
                // asientoContable.detalle.unshift(asientoContableDetalle);
				// asientoContable.detalle.unshift(asientoContableDetalle);     
				if(parametroContabilidad.tipo_saldo == 'H'){
					asientoContable.detalle.push(asientoContableDetalle);
					// asientoContableCobros.detalle.push(asientoContableDetalle);
				}else{
					asientoContable.detalle.unshift(asientoContableDetalle);
					// asientoContableCobros.detalle.unshift(asientoContableDetalle);   
				}     
            }
            
            if( parametroContabilidad.id == "36" && this.totalIva > 0) {
				parametroContabilidad.tipo_saldo = "H";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.totalIva:0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.totalIva:0;
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
                // asientoContable.detalle.unshift(asientoContableDetalle);
				// asientoContable.detalle.unshift(asientoContableDetalle);
				if(parametroContabilidad.tipo_saldo == 'H'){
					asientoContable.detalle.push(asientoContableDetalle);
					// asientoContableCobros.detalle.push(asientoContableDetalle);
				}else{
					asientoContable.detalle.unshift(asientoContableDetalle);
					// asientoContableCobros.detalle.unshift(asientoContableDetalle);   
				}     
			}
			
			if( parametroContabilidad.id == "33" && this.totalRenta > 0 ) {
				parametroContabilidad.tipo_saldo = "D";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.totalIva:0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.totalRenta:0;
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				// asientoContable.detalle.unshift(asientoContableDetalle);
				if(parametroContabilidad.tipo_saldo == 'H'){
					asientoContable.detalle.push(asientoContableDetalle);
					// asientoContableCobros.detalle.push(asientoContableDetalle);
				}else{
					asientoContable.detalle.unshift(asientoContableDetalle);
					// asientoContableCobros.detalle.unshift(asientoContableDetalle);   
				}     
                // asientoContableCobros.detalle.unshift(asientoContableDetalle);
			}
			
			if( parametroContabilidad.id == "34" && this.totalIva > 0 ) {
				parametroContabilidad.tipo_saldo = "D";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.totalIva:0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.totalIva:0;
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				// asientoContable.detalle.unshift(asientoContableDetalle);
				if(parametroContabilidad.tipo_saldo == 'H'){
					asientoContable.detalle.push(asientoContableDetalle);
					// asientoContableCobros.detalle.push(asientoContableDetalle);
				}else{
					asientoContable.detalle.unshift(asientoContableDetalle);
					// asientoContableCobros.detalle.unshift(asientoContableDetalle);   
				}     
                // asientoContableCobros.detalle.unshift(asientoContableDetalle);
            }

           
            
        });
        // let subtotal = 0;
        // this.retencion.detalle.forEach(rentaDetalle => {
			
        //     let asientoContableDetalle = new AsientoContableDetalle;
        //     asientoContableDetalle.empresa_id = asientoContable.empresa_id;
        //     asientoContableDetalle.usuario_id = asientoContable.usuario_id;
        //     asientoContableDetalle.debe = 0;
        //     let cuenta = asientoContable.detalle.filter( asientoDetalle=> rentaDetalle.cuenta_contable_id!=null && asientoDetalle.cuenta_contable_id == rentaDetalle.cuenta_contable_id );
			
		// 	if( cuenta.length > 0 ) {
        //         subtotal += rentaDetalle.total;
        //         let indexAsientoDetalle = asientoContable.detalle.findIndex(detalle => detalle.cuenta_contable_id === cuenta[0].cuenta_contable_id);
        //         asientoContable.detalle[indexAsientoDetalle].cuenta_contable_id = rentaDetalle.cuenta_contable_id;
        //         asientoContable.detalle[indexAsientoDetalle].haber = subtotal;
        //     }else if( cuenta.length == 0 && rentaDetalle.cuenta_contable_id !=null ) {
        //         subtotal += rentaDetalle.total;
        //         asientoContableDetalle.cuenta_contable_id = rentaDetalle.cuenta_contable_id;
        //         asientoContableDetalle.haber = rentaDetalle.total;
        //         asientoContable.detalle.push(asientoContableDetalle);
        //     }
        // });
        this.retencion.asientosContables.push(asientoContable);
    }

	

	onSubmit(){
		this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de confirmar la retención?").then(
			res => {
				this.setValueEntity();
				if( this.Mod_FactElec ){
					if( this.retencion.compra.proveedor.es_contribuyente ){
						if( this.retencion.compra.proveedor.num_contribuyente.toString().trim().length === 0 ){
							this.msgSweet.showMessage('error-message', "El proveedor no consta con número de contribuyente");
							return false;
						}
					}
					this.retencion.json_string = this.setRetencionElectronica();
				}

				this.compra.proveedor.correo = this.correos.toString();

				if( this.Mod_Cartera && this.Mod_Contabilidad ){

                    this.getPeriodoActual().then(
                        res => {
                            this.setValueAsientoContable();
                            this.saveRetencion();   
                        }
                    );
                }else {
                    this.saveRetencion();   
                }
			
			}
		);
	}

	saveRetencion(){
		this.loading = true;
		this.retencionService.save(this.retencion).subscribe(
			res => {
				this.loading = false;
				this.msgSweet.showMessage('success-message', res.message);

				this.compra = new Compra();
				this.retencion = new  Retencion();
				this.retencion_detalle = [];
				this.total = 0;
				this.correos = [];
				//this.is_numero_manual = false;
				this.numero_documento = "";
				this.caja = new Caja();
				this.totalRenta = 0;
				this.totalIva = 0;
				this.onIniDate();
				
				if( this.Mod_FactElec ){
					this.cbtContadorService.actualizarContador();
				}
				this.cerrarModal.emit({close: true, isSaved: true});
			},
			err => {
				this.compra = new Compra();
				this.retencion = new  Retencion();
				this.retencion_detalle = [];
				this.total = 0;
				this.correos = [];
				//this.is_numero_manual = false;
				this.numero_documento = "";
				this.caja = new Caja();
				this.totalRenta = 0;
				this.totalIva = 0;
				this.onIniDate();
				this.loading = false;
				this.msgSweet.showMessage('error-message',err);
			}
		);
	}

	getPeriodoActual(){
        return new Promise((resolve, reject) => {
            let qs = "?periodo=" + moment(this.retencion.fecha_emision.toString()).format('YYYY');
            this.periodoContableService.getPeriodoActual(qs).subscribe(
                res => {
                    this.periodoContable = res;
                    resolve();
                },
                err => {
                    reject(err);
                }
            );
        });
	}
	
	onCerrarModal(){
		this.cerrarModal.emit({close: true, isSaved: false});
	}

	setRetencionElectronica(){
        let retencionElectronica = {};
        retencionElectronica['datos'] = {};
        retencionElectronica['datos']['infoTributaria'] = {};
        retencionElectronica['datos']['infoTributaria']['ambiente'] = "";
        retencionElectronica['datos']['infoTributaria']['tipoEmision'] = 1;
        retencionElectronica['datos']['infoTributaria']['razonSocial'] = "";
        retencionElectronica['datos']['infoTributaria']['ruc'] = this.ss.getData('emp_ruc');
        retencionElectronica['datos']['infoTributaria']['claveAcceso'] = "";
        retencionElectronica['datos']['infoTributaria']['codDoc'] = "07"; //Retencion
        retencionElectronica['datos']['infoTributaria']['estab'] = this.retencion.serie;
        retencionElectronica['datos']['infoTributaria']['ptoEmi'] = this.retencion.punto_emision;
        retencionElectronica['datos']['infoTributaria']['secuencial'] = this.retencion.secuencial.toString().padStart(9,"0");
        retencionElectronica['datos']['infoTributaria']['dirMatriz'] = "";

        retencionElectronica['datos']['infoCompRetencion'] = {};
		retencionElectronica['datos']['infoCompRetencion']['fechaEmision'] =  moment(this.retencion.fecha_emision.toString()).format("DD/MM/YYYY");
		retencionElectronica['datos']['infoCompRetencion']['dirEstablecimiento'] =  (this.ss.getData('sucursal_direccion')).replace(/\//g,'-');
		if(this.compra.proveedor.es_contribuyente){
			retencionElectronica['datos']['infoCompRetencion']['contribuyenteEspecial'] =  this.compra.proveedor.num_contribuyente;
		}
		retencionElectronica['datos']['infoCompRetencion']['obligadoContabilidad'] =  (this.compra.proveedor.es_obligado == true ? "SI":"NO");
        retencionElectronica['datos']['infoCompRetencion']['tipoIdentificacionSujetoRetenido'] = this.compra.proveedor.tipoidentificacion.cod_dni;
        retencionElectronica['datos']['infoCompRetencion']['razonSocialSujetoRetenido'] = this.compra.proveedor.razon_social;
        retencionElectronica['datos']['infoCompRetencion']['identificacionSujetoRetenido'] = this.compra.proveedor.dni;
        retencionElectronica['datos']['infoCompRetencion']['periodoFiscal'] = moment(this.retencion.fecha_emision.toString()).format("MM/YYYY");

		retencionElectronica['datos']['impuestos'] = [];
        this.retencion_detalle.forEach((item: RetencionDetalle) => {
            let impuesto = {};
            impuesto['codigo'] = item.impuesto_id; //item.impuesto.codigo
            impuesto['codigoRetencion'] = item.codigo;
			impuesto['baseImponible'] = item.base_imponible;
			impuesto['porcentajeRetener'] = item.porcentaje;
			//impuesto['valorRetenido'] = Math.round(item.total * 100) / 100;
			impuesto['valorRetenido'] = this.utils.redondear(item.total,this.calculo_decimales);
			impuesto['codDocSustento'] = "01"; //Factura
			impuesto['numDocSustento'] = this.compra.serie + ""+this.compra.punto_emision + ""+this.compra.secuencial.toString().padStart(9,"0");
			impuesto['fechaEmisionDocSustento'] = moment(this.compra.fecha_emision.toString()).format("DD/MM/YYYY");
            retencionElectronica['datos']['impuestos'].push(impuesto);
        });
		
        retencionElectronica['datos']['infoAdicional'] = [];
        let adicional = {};
        adicional['Email'] = this.correos.toString();// this.compra.proveedor.correo;
		adicional['Direccion'] = (this.compra.proveedor.direccion).replace(/\//g,'-');
		
		let telefono = "0999999999";
        if( this.compra.proveedor.telefono.toString().trim().length > 0 ){
            telefono = this.compra.proveedor.telefono.toString();
        }
        if( this.compra.proveedor.celular.toString().trim().length > 0 ){
            telefono = this.compra.proveedor.celular.toString();
        }
		adicional['Telefono'] = telefono;

        retencionElectronica['datos']['infoAdicional'].push(adicional);

        return retencionElectronica;
    }

	setValueEntity(){
		this.retencion.tipo = "C";
		this.retencion.compra = this.compra;
		this.retencion.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD");
		this.retencion.is_secuencial_manual = this.is_numero_manual;
		if( this.is_numero_manual ) this.retencion.numero_documento = this.numero_documento;
		this.retencion.total = this.total;
		this.retencion.documento_id = this.compra.id;
		this.retencion_detalle.forEach(detalle => {
			if(detalle.impuesto_id == '2'){
				this.totalIva += parseFloat(detalle.total.toString());
			}
			else{
				this.totalRenta += parseFloat(detalle.total.toString());
			}
		});
		this.retencion.detalle = this.retencion_detalle;
		this.retencion.caja_id = this.caja.id;
		this.retencion.empresa_id = this.ss.getData('empresa_id');
		this.retencion.sucursal_id = this.ss.getData('sucursal_id');
		this.retencion.usuario_id = this.ss.getData('usuario_id');
	}

	recalcular(detalle_retencion){
		/*if( typeof event !== 'undefined' ){
			if( !event.target.value || event.target.value == 0 ){
				//detalle_retencion.porcentaje = 1;
			}else{
				//detalle_retencion.porcentaje = parseFloat(event.target.value);
			}
		}*/
		
		detalle_retencion.total = detalle_retencion.base_imponible * (detalle_retencion.porcentaje / 100);
		//detalle_retencion.total = Math.round(detalle_retencion.total * 100) / 100;
		detalle_retencion.total = this.utils.redondear(detalle_retencion.total, this.calculo_decimales);

		this.total = 0;
		this.retencion_detalle.forEach(detalle => {
			this.total += parseFloat(detalle.total.toString());
		});
	}

	recalcular2(){
		this.total = 0;
		this.retencion_detalle.forEach(detalle => {
			this.total += parseFloat(detalle.total.toString());
		});
	}

	isValidForm(){
		if( this.is_numero_manual ){
            if( this.numero_documento.trim().length === 0 ){
                return false;
            }else{
                if( parseFloat(this.numero_documento.trim()) < 1 ){
                    return false;
                }
            }
        }
		if( !this.retencion.numero_documento ){
			return false;
		}
		if( !this.compra.id ){
			return false;
		}
		/*if( !this.retencion_detalle.length ){
			return false;
		}*/
		if( this.retencion_detalle.length < 1 ){
			return false;
		}
		if( this.Mod_FactElec ){
			if( this.correos.length < 1 ){
				return false;
			}
			if( this.compra.proveedor.direccion.trim().length === 0 ){
                return false;
            }
		}
		let b = false;
		this.retencion_detalle.forEach(item => {
			if( item.base_imponible.toString().trim().length < 1 || item.base_imponible.toString() === "0"){
				b = true;
			}
			if( item.codigo.toString().trim().length < 1 ){
				b = true;
			}
		});
		if( b ){
			return false;
		}
		if(this.fecha_emision < this.fecha_MesAnt){
            return false;
		}
		if (this.correo_invalid) {
			return false;
		}
		return true;
	}

	onChangeImp(detalle: RetencionDetalle){
			detalle.codigo = "";
			detalle.total = 0;
			detalle.porcentaje = 0;
	}

	onDelete(i){
		this.retencion_detalle.splice(i, 1);
		this.recalcular2();
	}

	addDetalle(){
		let detalle = new RetencionDetalle();
		//detalle.base_imponible = parseFloat(this.compra.subtotal.toString());
		this.retencion_detalle.push(new RetencionDetalle());
	}

	gerPeriodoFiscal(){
		return moment(this.fecha_emision).format("MM/YYYY");
	}

	onChangeValorImp(detalle: RetencionDetalle){
		let imp_sel = this.impuesto_porcentaje_iva.filter(x => x.codigo == detalle.codigo)[0];
		detalle.porcentaje = imp_sel.porcentaje;
		detalle.total = parseFloat(detalle.base_imponible.toString()) * (parseFloat(imp_sel.porcentaje.toString()) / 100);
		//detalle.total = Math.round(detalle.total * 100) / 100;
		if( imp_sel ) detalle.cuenta_contable_id = imp_sel.cuenta_contable_id;
		detalle.total = this.utils.redondear(detalle.total,this.calculo_decimales);

		//this.recalcular({target:{value:0}},detalle);
		this.recalcular(detalle);
	}

	onChangeValorBase(detalle:RetencionDetalle){
		if(detalle.impuesto_id.toString() == '1'){
			detalle.base_imponible = parseFloat(this.compra.subtotal.toString());
		}
		else{
			detalle.base_imponible = parseFloat(this.compra.iva.toString());
		}

	}

	onEvento(detalle: RetencionDetalle, event?){
		if( detalle.codigo != "" ){
			if( event ){
				event.stopPropagation();
				if (event.key === "Enter" ) {
					this.obtenerPorcentaje(detalle);
					
				}
			}else{
				this.obtenerPorcentaje(detalle);
			}	
		}else{
			detalle.porcentaje = 0;	
		}
	}

	obtenerPorcentaje(detalle: RetencionDetalle){
		let imp_sel = this.impuesto_porcentaje_renta.filter(x => x.codigo.toLowerCase() === detalle.codigo.toLowerCase())[0];
		
		
		if( imp_sel ){
			detalle.porcentaje = imp_sel.porcentaje;	
			detalle.cuenta_contable_id = imp_sel.cuenta_contable_id;
		}else{
			this.msgSweet.showMessage('error-message', "No existe el código indicado");
			detalle.codigo = "";
			detalle.porcentaje = 0;            
		}
	}

	onVerImp(){
	}

	onChangeFecha(event){
        if(event < this.fecha_MesAnt){
            this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores al mes");            
        }
	}
	
	validarCorreo() {
		if (this.correos.length > 0) {
			let count_true = 0;
			let count_false = 0;
			for (let index = 0; index < this.correos.length; index++) {
				let res = this.correoService.isEmailValido(this.correos[index]);
				if (res) {
					count_true++;

				} else {
					count_false++;
				}

			}
			if (count_false > 0) {
				this.correo_invalid = true;
			} else {
				this.correo_invalid = false;
			}


		} else {
			this.correo_invalid = false;
		}
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/retenciones-compra-add/retenciones-compra-add.component.ts